import { render, staticRenderFns } from "./eventFinishedStatis.vue?vue&type=template&id=2afb54ee&scoped=true&"
import script from "./eventFinishedStatis.vue?vue&type=script&lang=js&"
export * from "./eventFinishedStatis.vue?vue&type=script&lang=js&"
import style0 from "./eventFinishedStatis.vue?vue&type=style&index=0&id=2afb54ee&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afb54ee",
  null
  
)

export default component.exports